<template>
    <div class="imageStyleBox">
        <div 
            v-for="(img) in imgList" 
            :class="{'imgBox': true, selectedImg: img.selected, bigImg: showBigImg ? true : false}"
            :key="img.style" 
            slot="reference"
            @click="handleClick(img)">
              <el-popover trigger="hover" placement="bottom-end" :visible-arrow="false" :close-delay="0" :open-delay="500">
                <img 
                  class="img" 
                  :src="img.url" alt="Image">
                <img 
                  slot="reference"
                  class="img" 
                  :src="img.largeImgUrl" alt="Image">
              </el-popover>
              <div class="imgDesc">{{ img.styleName }}</div>
          </div>
    </div>
</template>

<script>
export default {
  name: 'ImgStyleSelect',

  props: {
    options: {
      type: Array,
      required: true
    },
    showBigImg: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      imgList: this.options
    }
  },

  methods: {
    handleClick(img) {
      this.$emit('changeImg', img.style)
      this.imgList = this.imgList.map(item => ({
        ...item,
        selected: false
      }));

      this.imgList = this.imgList.map(item => {
        if (item.style === img.style) {
          return {
            ...item,
            selected: true
          }
        }

        return item;
      });
    }
  }
};
</script>

<style scoped lang="scss">
  .imageStyleBox {
      margin-top: 5px;
      width: 100%;
      // min-height: 210px;
      border-radius: 5px;
      display: flex;
      flex-wrap: wrap;
      justify-content: flex-start;
      align-content: space-around;
      overflow: hidden;

      .imgBox {
        width: 71px;
        height: 71px;
        cursor: pointer;
        margin: 5px 0 0 5px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        position: relative;
        overflow: hidden;

        .img {
          width: 100%;
          height: 100%;
          border-radius: 5px;
        }
        .img:hover {
          transform: scale(1.05);
        }

        .imgDesc {
          width: 87px;
          height: 20px;
          line-height: 20px;
          font-size: 13px;
          color: #fff;
          background: rgba($color: #000000, $alpha: 0.4) ;
          text-align: center;
          position: absolute;
          bottom: 0px;
          border-radius: 5px;
        }

        .checkIcon {
          position: absolute;
          top: 0px;
          right: 0px;
          color: #FE8015;
          font-weight: bold;
        }
      }

      .selectedImg {
        border: 2px solid #FE8015;
        border-radius: 5px;
        &:after {
          display: block;
          position: absolute;
          background-color: #ED7700;
          color: #FFF;
          width: 18px;
          height: 18px;
          font-size: 14px;
          line-height: 18px;
          top: 0;
          right: 0;
          z-index: 1;
          font-weight: 600;
          text-align: center;
          content: '✓';
        }
        .img {
          transform: scale(0.9) !important;
        }
      }

      .bigImg {
        width: 87px;
        height: 87px;
      }

    .imgBox:hover {
      color: #FE8015
    }
  }

  .rich {
    .imageStyleBox {
        .selectedImg {
          border: 2px solid #409eff;

          &:after {
            background-color: #3F9EFF;
          }

          .selectedImgDesc {
            color: #fff;
          }
        }

        .imgBox {
          .selectedImgDesc {
            color: #fff;
          }
        }
      }
  }
</style>